import './frequencies.scss';
